import { convertError } from './converters';
import { apiWrapper } from './helpers';

import { getGlobalState, STATE_KEYS } from '../configs/config_state';
import GLOBAL from '../configs/config_global';

// region Get Truck Reviews
export function getTruckReviews(currentPage = 1, pageSize = 5) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/reviews?per_page=${pageSize}&page=${currentPage}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => {
                if (typeof response === 'string') {
                    throw response;
                }
                else return(response.json());
            })
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] GET TRUCK REVIEWS', response);
                    resolve({
                        unreadCount: response['unread_count'],
                        data: response.data,
                        currentPage: response['current_page'],
                        lastPage: response['last_page'],
                        totalResult: response['total']
                    });
                }
                else {
                    console.log('[FAILED] GET TRUCK REVIEWS', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET TRUCK REVIEWS', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Send Review Reply
export function sendReviewReply(reviewID, text = '') {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/reviews/${reviewID}/reply`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ 'comment': text }),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] REPLY REVIEW', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] REPLY REVIEW', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] REPLY REVIEW', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Mark Review As Read
export function markReviewAsRead(reviewID) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/reviews/${reviewID}/read`,
        'PATCH',
        'Mark Review As Read'
    );
}
// endregion

// region Edit Reply
export function editReviewReply(reviewID, replyID, newReplyContent = '') {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/reviews/${reviewID}/reply/${replyID}`,
        'PATCH',
        'Edit Review Reply',
        JSON.stringify({ comment: newReplyContent }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Delete Reply
export function deleteReviewReply(reviewID, replyID) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/reviews/${reviewID}/reply/${replyID}`,
        'DELETE',
        'Remove Review Reply'
    );
}
// endregion
